import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import loginReducer from '../components/authUI/loginSlice'
import authReducer from './reducers/authReducer'
import tableReducer from '../components/table/tableSlice'

const persistConfig = {
  key: 'root',
  storage: storageSession,
}

const rootReducer = combineReducers({
  login: loginReducer,
  auth: authReducer,
  table: tableReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'table/fetchApps/fulfilled',
          'table/fetchAppsFailure',
          'table/fetchFactTableAppsFailure',
          '/table/fetchFactTableApps/fulfilled',
          '/table/fetchMetrics/fulfilled',
          'table/fetchMetricsFailure',
        ],
      },
    }),
})

const persistor = persistStore(store)

export { store, persistor }
